import {  postDigioRequest } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_digio_requestThunk = createAsyncThunk(
  "reKyc_digio_requestThunk",
  async ({ params, token }) => {
    try {
      const response = postDigioRequest(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
